import React from "react";

const Thankyou = () => {
  return (
    <div>
     <div id="colorlib-main">
        <section className="ftco-section ftco-no-pt ftco-no-pb" style={{ height: "100vh", margin: "auto",    alignItems: "center",
    display: "flex"}}
   
>
          <div className="row d-flex">
 <div className="row">
              {/* Left Section - Image */}
              <div
                className="col-md-6"
                style={{ borderRight: "8px solid rgb(198 87 160)" }}
              >
                <img
                  decoding="async"
                  fetchPriority="high"
                  style={{ width: "100%" }}
                  className="m-auto"
                  src="https://medcaretrust.com/static/media/thankyou.dd9a299de338dea08c79.webp"
                  alt="digital-marketing"
                />
              </div>

              {/* Right Section - Message */}
              <div className="col-md-6 d-flex align-items-center">
                <h3 className="mt-3">
                 Thank you for choosing our salon!
Your details have been successfully received. Our beauty experts will get in touch with you shortly to confirm your appointment and assist you further.
                  <br />
                  <br />
                  <a
                    style={{
                      background: "#rgb(198 87 160)",
                      color: "#fff",
                      padding: "7px 15px",
                      borderRadius: "37px",
                      display: "inline-block",
                      textDecoration: "none",
                    }}
                    href="https://wa.me/+919915447777"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className=" bi bi-whatsapp text-success" size={20} />{" "}
                    WhatsApp
                  </a>
                </h3>
              </div>
            </div>
            </div>
            </section>
            </div>
    </div>
  );
};

export default Thankyou;
